class ProductSlider {
  constructor () {
    this.screen = null;
    this.mainSlider = null;
    this.thumbsSlider = null;
    this.pointMobile = 989;
    this.load();
  }

  load () {
    document.addEventListener("DOMContentLoaded", () => {
      this.init();
    });

  }

  init () {
    if (this.setScreen()) {
      this.initSliders();
    }

    window.addEventListener("resize", () => {
      this.setScreen();
    });
    this.setEventNextBtn();
  }

  setEventNextBtn () {
    const elems = document.querySelector(".js-product-arrow-next");
    if (elems) {
      elems.addEventListener("click", () => {
        this.thumbsSlider.slideNext();
      });
    }
  }

  setScreen () {
    let screenWidth = window.innerWidth >= this.pointMobile ? "desktop" : "mobile";
    if (screenWidth !== this.screen) {
      this.screen = screenWidth;
      this.initSliders();
    }
  }

  initSliders () {
    this.initThumbsSlider();
    this.initMainSlider();
  }

  initThumbsSlider () {
    let length = document.querySelectorAll(".js-product-thumbs .swiper-slide").length;
    length = length >= 7 ? 7 : length;
    this.thumbsSlider = new Swiper(".js-product-thumbs", {
      direction: "vertical",
      slidesPerView: 4,
      loop: true,
      // navigation: {
      //   nextEl: ".swiper-button-next"
      // },
      breakpoints: {
        1024: {
          slidesPerView: length
        }
      }
    });
  }

  initMainSlider () {
    this.mainSlider = new Swiper(".js-product-slider", {
      slidesPerView: 1,
      loop: true,
      clickable: true,
      lazy: {
        loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
        loadPrevNextAmount: 1 //or, if you wish, preload the next 2 images
      },
      thumbs: {
        swiper: this.thumbsSlider || ""
      },
      // pagination: {
      //   el: document.querySelector(".js-product-slider-bullets"),
      //   type: "bullets",
      //   clickable: true,
      //   bulletActiveClass: "bullets__item--active",
      //   bulletClass: "bullets__item",
      //   renderBullet: function (index, className) {
      //     return "<span class=\"" + className + "\" ><span class=\"bullets__dot\">" + "</span></span>";
      //   }
      // },
      on: {
        slideChange () {
          const mutes = document.querySelectorAll(".js-video-mute:not(.mute)");
          if (mutes) {
            mutes.forEach(button => {
              button.click();
            });
          }
        },
        afterInit () {
          const minContainer = document.querySelector(".js-set-height-slider");
          const height = document.querySelector(".js-product-slider").offsetHeight;
          minContainer.style.minHeight = height + 64 + "px";
          reInitVideoPlayer();
        }
      },
      breakpoints: {
        990: {
          loop: false,
          autoHeight: false
        }
      }
    });

  }

  sliderReInit () {
    if (this.thumbsSlider !== null) this.thumbsSlider.destroy(true, true);
    if (this.mainSlider) {
      this.mainSlider.destroy(true, true);
      this.mainSlider = null;
    }
    this.initSliders();
  }
}

var productSlider = new ProductSlider();
